import { registerCustomAdaptiveCardActions } from './registerCustomAdaptiveCardActions';
import { registerCustomAdaptiveCardElements } from './registerCustomAdaptiveCardElements';
import subscribeToPrimeNotification from './subscribeToPrimeNotification';
import { applyOptions } from '../actions/activityFeedApplyOptions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { initializeFileTypeIcons } from '@uifabric/file-type-icons';
import loadActivityFeedSettings from './loadActivityFeedSettings';
import postWeveSignal from '../service/postWeveSignal';

initializeFileTypeIcons();

export const initializeActivityFeed = () => {
    if (isFeatureEnabled('auth-activityFeed')) {
        registerCustomAdaptiveCardElements();
        registerCustomAdaptiveCardActions();
        applyOptions();
        if (isFeatureEnabled('auth-activityFeedWeveSignal')) {
            postWeveSignal();
        }
        loadActivityFeedSettings();
        if (isFeatureEnabled('auth-activityFeedPrimeNotification')) {
            subscribeToPrimeNotification();
        }
    }
};
